import { IconUser } from '@tabler/icons-react';
export default function Avatar() {
  return <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-primary" data-sentry-component="Avatar" data-sentry-source-file="avatar.tsx">
      <span className="text-md font-medium leading-none text-white">
        <IconUser size={20} data-sentry-element="IconUser" data-sentry-source-file="avatar.tsx" />
      </span>
    </span>;
}